import { createCompatibleUserStorage } from "./integratedAuthStorage";
import { createTokenStorage } from "./tokenStorage";
import { CryptoHelper } from "../security/cryptoHelper";
import type { ConfigurationEncode } from "../security/configurationEncode";

export interface CreateStorageOptions {
  userStorageKey: string;
  tokenStorageKey: string;
  encoder?: ConfigurationEncode;
}

export const createStorage = (options: CreateStorageOptions) => {
  const encoder = options.encoder ?? {
    key: "KEYencodeECMABCDEFGHSAGIJKLMNCore",
    keyLength: 32,
    iv: "IVencodeECMABCDEF",
    ivLength: 16,
  };

  const userStorage = createCompatibleUserStorage({
    userStorageKey: options.userStorageKey,
    tokenStorageKey: options.tokenStorageKey,
    encoder,
  });

  const authTokenStorage = createTokenStorage(options.tokenStorageKey, {
    encrypt: (plain: string) => CryptoHelper.encrypt(encoder, plain),
    decrypt: (cipher: string) => CryptoHelper.decrypt(encoder, cipher),
  });

  const clearAuthSession = () => {
    userStorage.removeFromStorage();
    authTokenStorage.clear();
  };

  const getAccessToken = () => authTokenStorage.getAccessToken();
  const getRefreshToken = () => authTokenStorage.getRefreshToken();
  const saveAuthTokens = (accessToken: string, refreshToken: string) => {
    authTokenStorage.save(accessToken, refreshToken);
  };

  return {
    userStorage,
    authTokenStorage,
    clearAuthSession,
    getAccessToken,
    getRefreshToken,
    saveAuthTokens,
  };
};


